import { faqs } from "data/questions";
import React, { useState } from "react";
import { FaUser } from "react-icons/fa";
import { FaCalendarDays } from "react-icons/fa6";
import { IoHome } from "react-icons/io5";
import { MdOutlinePayment } from "react-icons/md";
import { SiSpringsecurity } from "react-icons/si";

const img = require("../../images/faq2.png");
interface FAQItemProps {
  question: string;
  answer: string | JSX.Element;
  className?: string;
}

const FAQItem: React.FC<FAQItemProps> = ({ question, answer, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className={`py-3  faq-item ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between w-full text-lg font-medium text-left"
      >
        {question}
        <span>{isOpen ? "-" : "+"}</span>
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? "max-h-screen opacity-100 py-2" : "max-h-0 opacity-0 py-0"
        }`}
      >
        <p className="mt-2 text-sm text-gray-600">{answer}</p>
      </div>
    </div>
  );
};

const HelpCenter: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string>("fq");

  const categories = [
    { name: "Utilisateurs", prefix: "Utilisateurs", icon: <FaUser /> },
    { name: "Sécurité et politique d'annulation", prefix: "sécurité", icon: <SiSpringsecurity /> },
    { name: "Paiement et tarifs", prefix: "paiement", icon: <MdOutlinePayment /> },
    { name: "Hôte des espaces", prefix: "hôte", icon: <IoHome /> },
    { name: "Réservation", prefix: "réservation", icon: <FaCalendarDays /> },
    { name: "Prestataire", prefix: "prestataire", icon: <FaUser /> },
  ];
  const [searchQuery, setSearchQuery] = useState<string>("");
  const filteredFAQs = faqs[selectedCategory]?.filter(
    (faq: any) =>
      faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      faq.answer.toString().toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="font-sans">
      {/* Search Section */}
      <section
        className="py-10 text-center bg-white "
        style={{
          backgroundImage: `url(${img})`,
          backgroundSize: "cover",

          backgroundRepeat: "no-repeat",
          height: "30vh",
          width: "100%",
        }}
      >
        <h2 className="mb-4 text-3xl font-semibold text-white">Comment pouvons-nous vous aider ?</h2>
        <div className="relative max-w-lg mx-auto mt-10">
          <input
            type="text"
            placeholder="Posez votre question ou entrez des mots-clés ici"
            className="w-full px-5 py-3 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-primary-500"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button className="absolute px-2 py-2 text-white transform -translate-y-1/2 rounded-full bg-primary-500 right-1 top-1/2">
            Recherche
          </button>
        </div>
      </section>

      {selectedCategory === "fq" ? (
        <>
          <section className="grid max-w-4xl grid-cols-1 gap-4 py-10 mx-auto sm:grid-cols-3 md:grid-cols-2 dark:bg-neutral-800">
            {categories.map((category, index) => (
              <div
                key={index}
                className={`flex flex-col items-start justify-center p-4 rounded-md shadow-sm cursor-pointer space-y-2 ${
                  selectedCategory === category.prefix.toLowerCase()
                    ? "bg-primary-500 text-white"
                    : "bg-gray-100 text-gray-700"
                }`}
                onClick={() => setSelectedCategory(category.prefix.toLowerCase())}
              >
                <div className="flex items-center justify-center space-x-3">
                  {" "}
                  <div className="text-2xl">{category.icon}</div>
                  <h3
                    className={`text-lg font-medium ${
                      selectedCategory === category.prefix.toLowerCase() ? "text-white" : "text-gray-700"
                    }`}
                  >
                    {category.name}
                  </h3>
                </div>
              </div>
            ))}
          </section>

          <section className="py-10 bg-gray-50 dark:bg-neutral-800">
            <h2 className="mb-6 text-2xl font-semibold text-center ">Questions fréquemment posées</h2>
            <div className="max-w-4xl mx-auto">
              {filteredFAQs && filteredFAQs.length > 0 ? (
                filteredFAQs.map((faq: any, index: any) => (
                  <FAQItem key={index} question={faq.question} answer={faq.answer} />
                ))
              ) : (
                <p className="text-center text-gray-500">Aucune FAQ ne correspond à votre recherche.</p>
              )}
            </div>
          </section>
        </>
      ) : (
        <>
          <div className="flex space-x-9">
            <section className="grid items-center gap-2 py-10 pl-36 dark:bg-neutral-800 ">
              {categories.map((category, index) => (
                <div
                  key={index}
                  className={`flex flex-col items-start justify-center p-4 rounded-md shadow-sm cursor-pointer space-y-2 ${
                    selectedCategory === category.prefix.toLowerCase()
                      ? "bg-primary-500 text-white"
                      : "bg-gray-100 text-gray-700"
                  }`}
                  onClick={() => setSelectedCategory(category.prefix.toLowerCase())}
                >
                  <div className="flex items-center justify-center space-x-3">
                    {" "}
                    <div className="text-2xl">{category.icon}</div>
                    <h3
                      className={`text-lg font-medium ${
                        selectedCategory === category.prefix.toLowerCase() ? "text-white" : "text-gray-700"
                      }`}
                    >
                      {category.name}
                    </h3>
                  </div>
                </div>
              ))}
            </section>

            <section className="py-10 mt-5 dark:bg-neutral-800">
              <h2 className="mb-6 text-2xl font-semibold text-left text-eventToBee ">
                {selectedCategory.charAt(0).toLocaleUpperCase() + selectedCategory.slice(1).toLocaleLowerCase()}
              </h2>
              <div className="">
                {filteredFAQs && filteredFAQs.length > 0 ? (
                  filteredFAQs.map((faq: any, index: any) => (
                    <FAQItem
                      key={index}
                      question={faq.question}
                      answer={faq.answer}
                      className="p-3 mt-2 border-2 rounded-lg border-eventToBee"
                    />
                  ))
                ) : (
                  <p className="text-center text-gray-500">Aucune FAQ ne correspond à votre recherche.</p>
                )}
              </div>
            </section>
          </div>
        </>
      )}
    </div>
  );
};

export default HelpCenter;
